module.exports = "/packs/templates.dialog.product.quick_cart-8826859c.html";